@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate" style="margin-top: 0"></mat-progress-bar>
}




<div style="width: 850px;margin-left: 40px; margin-top: 40px"
  ngClass.xs="page-margin-xs"
  ngClass.sm="page-margin-sm"
  ngClass="page-margin">

  <div>
    <mat-list>
      <mat-list-item>Clients</mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
  </div>


  <div [hidden]="is_loading">

    <div style="margin-top: 20px; margin-bottom: 20px;">

      <ng-container>
        <button mat-fab aria-label="Add User" (click)="addClient(false, {})" matTooltip="Add User"
          matTooltipPosition="right">
          <mat-icon class="add-button">add</mat-icon>
        </button>
      </ng-container>
    </div>

    <div>
      <mat-form-field>
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
      </mat-form-field>

      <div ngClass="table-width" ngClass.xs="table-width-xs" ngClass.sm="table-width-sm">
        <mat-card class="mat-elevation-z24">
          <div class="mat-elevation-z24">
            <table mat-table [dataSource]="dataSource" matSort>

              <!-- Client Id Column -->
              <ng-container matColumnDef="client_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Client ID</th>
                <td mat-cell *matCellDef="let row">{{row.client_id}}</td>
              </ng-container>

              <!-- Client Slug Column -->
              <ng-container matColumnDef="client_slug">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Slug</th>
                <td mat-cell *matCellDef="let row">{{row.client_slug}}</td>
              </ng-container>

              <!-- Client Name Column -->
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Client Name</th>
                <td mat-cell *matCellDef="let row">{{row.name}}</td>
              </ng-container>

              <ng-container matColumnDef="Select">
                <th mat-header-cell *matHeaderCellDef>
                  Select
                </th>
                <td mat-cell *matCellDef="let row; let i = index">
                  <mat-radio-group [(ngModel)]="selectedRowIndex">
                    <mat-radio-button [value]="i" (change)="onSelect(row)"></mat-radio-button>
                  </mat-radio-group>
                </td>
              </ng-container>

              <ng-container matColumnDef="Edit">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Edit</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button class="any-icon-primary table-icon" (click)="addClient(true,  row)">
                    <mat-icon color="accent" style="cursor: pointer;">edit</mat-icon>
                  </button>
                </td>
              </ng-container>



              <!-- Delete Column -->
              <ng-container matColumnDef="Delete">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Delete</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-icon-button class="warn-icon-primary table-icon" (click)="deleteRow(row)">
                    <mat-icon color="warn" style="cursor: pointer;">delete</mat-icon>
                  </button>
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"
              (click)="getTableRecord(row)"></tr>
            </table>


            <mat-paginator [pageSizeOptions]="[5, 10, 20]"
              showFirstLastButtons
              aria-label="Select page of periodic elements">
            </mat-paginator>
          </div>
        </mat-card>
      </div>
    </div>
  </div>



</div> <!--end flex container-->


